import { SupplierNumberPage } from '@features/ForestOwner/Property/SupplierNumber/SupplierNumberPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/$forestownerId/property/supplier-number')({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Hent eller opprett leverandørnummer',
  },
})

function RouteComponent() {
  return <SupplierNumberPage />
}
